// 링크 복사 성공 메시지 (여러 feature가 공유하는 범용 문구)
export const LINK_COPY_SUCCESS_MESSAGE =
  '주소가 복사되었습니다.\n원하는 곳에 붙여넣기 해주세요!'

/**
 * 텍스트를 클립보드에 복사합니다.
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false
  }
}
